/* tslint:disable */
/* eslint-disable */
export enum ApplicationCustomerType {
  None = 'None',
  Individual = 'Individual',
  Company = 'Company'
}
